export default "__VITE_ASSET__BqJRJDxp__"